import { render, staticRenderFns } from "./chooseForm.vue?vue&type=template&id=b26bf61a&"
import script from "./chooseForm.vue?vue&type=script&lang=js&"
export * from "./chooseForm.vue?vue&type=script&lang=js&"
import style0 from "./chooseForm.vue?vue&type=style&index=0&id=b26bf61a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports